import { tss } from 'tss-react/mui';

const useStyles = tss.create(() => ({
  cloudSourceExportDialogDialogContent: {
    alignItems: 'center',
    display: 'flex',
    height: 600,
    justifyContent: 'center',
    paddingBottom: '0.5rem'
  },
  cloudSourceExportDialogIconButtonCancel: {
    height: '2rem',
    position: 'absolute',
    right: 8,
    top: 8,
    width: '2rem'
  }
}));

export default useStyles;
